import Icon from '../docs/Icon'
import AgencyMark from '../marks/AgencyMark'
import Flag from '../marks/Flag'
import { BANNER } from '@/content/identity'
import type { Mission } from '@/content/missions'
import { usePrefs } from '@/state/prefs'

/**
 * A sample agency home page in the mission's theme. It is a picture of the
 * theme, not a working site: links and controls are inert text.
 */
export default function AgencySitePreview({ mission, mode }: { mission: Mission; mode: 'light' | 'dark' }) {
  const { prefs } = usePrefs()
  const nation = mission.kind === 'nation'
  const name = nation ? 'America' : mission.name
  return (
    <figure className="msn-site">
      <figcaption className="msn-site__caption">{mode === 'light' ? 'Light' : 'Dark'}</figcaption>
      <div className="msn-site__frame" aria-hidden="true" data-mission={mission.id} data-theme={mode}>
        <div className="msn-site__banner">
          <Flag variant="official" className="msn-site__flag" />
          {nation ? BANNER.site : BANNER.official}
          <Icon name="info" size={11} />
        </div>
        <div className="msn-site__header">
          <AgencyMark mission={mission} variant={prefs.mark} className="msn-site__mark" />
          <span className="msn-site__wordmark">{nation ? 'America' : mission.short}</span>
          <span className="msn-site__menu">Menu</span>
        </div>
        <div className="msn-site__hero">
          <p className="msn-site__title">{nation ? 'Hello, America' : name}</p>
          <p className="msn-site__lead">{mission.mission.text}</p>
          <span className="msn-site__pill">
            <span>How can we help you today?</span>
            <span className="msn-site__send">
              <Icon name="arrow" size={14} />
            </span>
          </span>
        </div>
        <div className="msn-site__cards">
          {['Services', 'News', 'About'].map((label, index) => (
            <span key={label} className="msn-site__card">
              <span className="msn-site__card-eyebrow">{label}</span>
              <span className="msn-site__card-title">
                {['Find a program', 'Latest updates', 'Our mission'][index]}
              </span>
              {index === 0 && <span className="msn-site__tag">New</span>}
            </span>
          ))}
        </div>
      </div>
    </figure>
  )
}
